<template>
  <v-dialog v-model="dialog" persistent max-width="680" scrollable>
    <v-card class="rounded-lg">
      <v-card-title class="pa-5 pb-3 d-flex align-center gap-2">
        <v-icon color="#10b981" size="28">mdi-shield-account-outline</v-icon>
        <div>
          <div style="font-size:16px; font-weight:700; line-height:1.3">Data Privacy Notice</div>
          <div style="font-size:12px; font-weight:400; color:#6b7280; margin-top:2px">
            Republic Act No. 10173 – Data Privacy Act of 2012
          </div>
        </div>
      </v-card-title>

      <v-divider />

      <v-card-text style="max-height:420px; overflow-y:auto; padding:20px 24px;">
        <p style="font-size:13px; color:#374151; line-height:1.7; margin-bottom:14px;">
          In compliance with the <strong>Republic Act No. 10173</strong>, otherwise known as the
          <strong>Data Privacy Act of 2012</strong>, and its Implementing Rules and Regulations,
          <strong>Davao del Norte State College (DNSC)</strong> is committed to protecting your
          personal information and ensuring it is processed lawfully, fairly, and transparently.
        </p>

        <div style="font-size:13px; color:#111827; font-weight:600; margin-bottom:6px;">
          What information we collect
        </div>
        <p style="font-size:13px; color:#374151; line-height:1.7; margin-bottom:14px;">
          As part of the Student Internship Program in the Philippines (SIPP) / On-the-Job Training
          (OJT) management process, we collect and process the following personal data:
        </p>
        <ul style="font-size:13px; color:#374151; line-height:1.9; margin-bottom:14px; padding-left:20px;">
          <li>Full name, student ID, contact details, and sex</li>
          <li>Academic information (program, year level, section, batch)</li>
          <li>Internship deployment records (HTE assignment, deployment dates)</li>
          <li>Attendance and daily time records (DTR)</li>
          <li>Performance evaluations and assessment scores</li>
          <li>Documents submitted in connection with the OJT program</li>
        </ul>

        <div style="font-size:13px; color:#111827; font-weight:600; margin-bottom:6px;">
          Purpose of data collection
        </div>
        <p style="font-size:13px; color:#374151; line-height:1.7; margin-bottom:14px;">
          Your personal data is collected and processed solely for the following purposes:
        </p>
        <ul style="font-size:13px; color:#374151; line-height:1.9; margin-bottom:14px; padding-left:20px;">
          <li>Administration and monitoring of OJT/SIPP programs</li>
          <li>Generation of official reports required by CHED and partner institutions</li>
          <li>Evaluation and assessment of student performance during internship</li>
          <li>Communication between students, coordinators, HTE supervisors, and school officials</li>
          <li>Compliance with government regulatory requirements</li>
        </ul>

        <div style="font-size:13px; color:#111827; font-weight:600; margin-bottom:6px;">
          Data sharing
        </div>
        <p style="font-size:13px; color:#374151; line-height:1.7; margin-bottom:14px;">
          Your personal data may be shared with Host Training Establishments (HTEs), CHED, and
          authorized school officials strictly on a need-to-know basis and only to the extent
          necessary for the purposes stated above. Data will not be sold, rented, or disclosed to
          third parties for commercial purposes.
        </p>

        <div style="font-size:13px; color:#111827; font-weight:600; margin-bottom:6px;">
          Your rights
        </div>
        <p style="font-size:13px; color:#374151; line-height:1.7; margin-bottom:14px;">
          Under RA 10173, you have the right to be informed, access your personal data, object to
          processing, erasure or blocking of data, damages, and file a complaint before the National
          Privacy Commission (NPC). For concerns, contact the DNSC Data Protection Officer.
        </p>

        <div
          style="background:#f0fdf4; border:1px solid #bbf7d0; border-radius:8px; padding:12px 14px; font-size:12.5px; color:#166534; line-height:1.6;"
        >
          By clicking <strong>"I Agree"</strong>, you acknowledge that you have read, understood,
          and consent to the collection and processing of your personal data by Davao del Norte State
          College for the purposes described above, in accordance with RA 10173 and its IRR.
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          color="#10b981"
          variant="flat"
          class="text-white px-6"
          prepend-icon="mdi-check-circle-outline"
          :loading="loading"
          @click="agree"
        >
          I Agree
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DataPrivacyModal",
  emits: ["agreed"],

  data() {
    return {
      dialog: true,
      loading: false,
    };
  },

  methods: {
    async agree() {
      this.loading = true;
      try {
        await this.axiosCall("/auth/agree-privacy", "POST");
      } catch (e) {
        console.error("Failed to record privacy agreement", e);
      } finally {
        // Also persist locally as a fast-path cache
        const userId = this.$store.state.user?.user?.id;
        if (userId) {
          localStorage.setItem(`privacy_agreed_${userId}`, "1");
        }
        this.loading = false;
        this.dialog = false;
        this.$emit("agreed");
      }
    },
  },
};
</script>
